import { PanelMatrixComponent } from 'app/shared/components/panels/matrix/matrix.component';
import { PanelsCommentsComponent } from '../comments/comments.component';
import { PanelsContactsComponent } from '../contacts/contacts.component';
import { PanelsFormComponent } from '../form/form.component';
import { PanelsImagesComponent } from '../images/images.component';
import { PanelsMapComponent } from '../map/map.component';
import { PanelsUnitFormComponent } from '../unit-form/unit-form.component';
import { PanelsUnitLeaseComponent } from '../unit-lease/unit-lease.component';
import { PanelsRelatedTableComponent } from 'app/modules/properties/details/dashboard/panels/related-table/related-table.component';
import { PropertyChartPanelComponent } from '../chart/property-chart-panel.component';
import { FinancialReportPanelComponent } from '../financial-report/financial-report-panel.component';

const PropertyPanels = {
  form: PanelsFormComponent,
  unit_form: PanelsUnitFormComponent,
  images: PanelsImagesComponent,
  comments: PanelsCommentsComponent,
  map: PanelsMapComponent,
  unit_lease: PanelsUnitLeaseComponent,
  contacts: PanelsContactsComponent,
  matrix: PanelMatrixComponent,
  table: PanelsRelatedTableComponent,
  roles: PanelsFormComponent,
  chart: PropertyChartPanelComponent,
  financial_report: FinancialReportPanelComponent,
} as const;

export default PropertyPanels;
